import { IEmployeesDto } from "../dtos/employees";

export class Employee {
  readonly id: string;
  lastName: string;
  firstName: string;
  middleName: string;
  fullName: string | null; // "| null" inherited from IEmployeesDto
  positionName: string;
  importFarmName: string;
  workPlaceId: string;
  appUserId?: string;

  constructor(id: string) {
    this.id = id;
  }

  get asDto(): IEmployeesDto {
    return {
      id: this.id,
      lastName: this.lastName,
      firstName: this.firstName,
      middleName: this.middleName,
      fullName: this.fullName,
      positionName: this.positionName,
      importFarmName: this.importFarmName,
      workPlaceId: this.workPlaceId,
      appUserId: this.appUserId,
    };
  }

  updateFromDto(dto: IEmployeesDto): void {
    this.lastName = dto.lastName;
    this.firstName = dto.firstName;
    this.middleName = dto.middleName;
    this.fullName = dto.fullName;
    this.positionName = dto.positionName;
    this.importFarmName = dto.importFarmName;
    this.workPlaceId = dto.workPlaceId;
    this.appUserId = dto.appUserId;
  }
}
